// extracted by mini-css-extract-plugin
module.exports = {"container":"e_oA","icon":"e_pA"};